export default function PHP_Exception_Main() {
  return (
    <div>
      <h1>PHP_Exception_Main</h1>
    </div>
  );
}
